import { z } from 'zod';

import { PayoffId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertPayoffSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  payoffId: PayoffId,
});
/**
 * @deprecated Use upsertPayment instead
 */
export const UpsertPayoffSideEffect = UpsertPayoffSideEffectContext.extend({
  type: z.literal('upsertPayoff'),
});
export type UpsertPayoffSideEffect = z.infer<typeof UpsertPayoffSideEffect>;
